import { jsx as _jsx } from "react/jsx-runtime";
import HomepageHeaderContent from '../components/HomepageHeaderContent';
import { TrackerContext } from 'connect-dot-com-ui-components/context/TrackerContext';
import { trackPageview, trackInteraction } from '../utils/usageTracker';
import { useEffect } from 'react';
import HomepageLayout from '../components/layout/Homepage/HomepageLayout';

const Homepage = ({
  children
}) => {
  useEffect(() => {
    trackPageview('homepage');
  }, []);
  return /*#__PURE__*/_jsx(TrackerContext.Provider, {
    value: {
      trackPageview,
      trackInteraction
    },
    children: /*#__PURE__*/_jsx(HomepageLayout, {
      header: /*#__PURE__*/_jsx(HomepageHeaderContent, {}),
      children: children
    })
  });
};

export default Homepage;